import React from "react";
import { sdsuStageImages } from "../../../utils/imageResources";

import SceneObject from "../../SceneObject";



const SdsuSign = React.memo(props => {
    return (
        <SceneObject
            name="SdsuSign"
            transform={{
                position: props.transform.position,
                scale: props.transform.scale,
                rotation: props.transform.rotation,
                opacity: 1
            }}
            $imgUrl={sdsuStageImages.SdsuSignImg}
        />
    );
});

export default SdsuSign;
